// extracted by mini-css-extract-plugin
module.exports = {"textareaTag":"textarea_textareaTag__UZsNd"};